<template>
  <span><template v-for="(line, i) in lines"><br v-if="i > 0" :key="`br-${i}`"><span :key="`line-${i}`">{{ line }}</span></template></span>
</template>

<script>
// Shows server supplied text, one line per <br> separator or newline, without ever treating the
// value as HTML. The server joins addresses with the literal '<br>' and log text uses newlines.
export default {
  name: 'AppMultilineText',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  computed: {
    lines() {
      const text = this.value === null || this.value === undefined ? '' : String(this.value)
      return text.split(/<br\s*\/?>|\r\n|\r|\n/i)
    }
  }
}
</script>
